/* Uitklappen van de reviewlijst.

   Het inklappen zelf zit in CSS (`:not([data-open])`), zodat de lijst ook
   zonder JavaScript ingeklapt staat in plaats van als volledige muur tekst.
   Deze knop zet alleen het attribuut en verdwijnt daarna. */

document.addEventListener('click', (event) => {
  const knop = event.target.closest('[data-onvela-reviews-meer]');
  if (!knop) return;

  const lijst = knop.closest('.onvela-reviews')?.querySelector('.onvela-reviews__list');
  if (!lijst) return;

  lijst.setAttribute('data-open', '');
  knop.remove();
});
